import { AlertsOverviewPage } from './pages/alerts-overview';

export function AlertsPage() {
  return <AlertsOverviewPage />;
}
